import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    Card,
    CardContent,
    CardHeader,
    Divider,
    TextField,
} from '@material-ui/core';
import { ILeadContactedStatus } from './types';

/**
 * Represent the contact status of a lead
 *
 * @param {*} { isContacted, ...props }
 * @return {*}
 */
export const LeadContactedStatus = ({
    isContacted,
    ...props
}: ILeadContactedStatus) => {
    const { t } = useTranslation();

    return (
        <Card {...props}>
            <CardHeader title={t('Leads.Contacted')} />
            <Divider />
            <CardContent>
                <TextField
                    fullWidth
                    name="isContacted"
                    select
                    SelectProps={{ native: true }}
                    disabled
                    variant="outlined"
                >
                    <option>
                        {isContacted
                            ? t('Leads.Contacted')
                            : t('Leads.NoContacted')}
                    </option>
                </TextField>
            </CardContent>
        </Card>
    );
};
